function isDataEmpty(data) {
  return !data || Object.values(data).every((fieldValue) => {
    return fieldValue === null || isFieldEmptyArray(fieldValue);
  });
}
function isFieldEmptyArray(field) {
  return Array.isArray(field) && field.length === 0;
}
export {
  isDataEmpty
};
